import axios from 'axios';
import { axiosBlobErrorInterceptor } from 'utils/download';

const apiClient = axios.create({
  baseURL: `${payload.services.documentservice.url}/api/v2/msds`,
  headers: {
    'request-region': payload.generic.requestRegion
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  axiosBlobErrorInterceptor,
);

let languages;
let types;

export default {
  async getConfigOptions(token = null) {
    if (!languages) {
      languages = await this.fetchLanguages(token);
    }

    if (!types) {
      types = await this.fetchTypes(token);
    }

    return {
      languages,
      types,
    };
  },
  async fetchLanguages(token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    return (await apiClient.get('/languages', config)).data;
  },
  async fetchTypes(token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    return (await apiClient.get('/types', config)).data;
  },
  async triggerDownload(emg, language, type, token = null) {
    const config = {};
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      };
    }

    return apiClient.post('/document', {
      emg,
      language,
      type,
    }, config);
  }
};
